
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import CorporateHeroSection from './components/CorporateHeroSection';
import TrainingApproachSection from './components/TrainingApproachSection';
import ProgrammesSection from './components/ProgrammesSection';
import WhyChooseSection from './components/WhyChooseSection';
import SETAFundingSection from './components/SETAFundingSection';
import GetStartedSection from './components/GetStartedSection';

export default function CorporateTrainingPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <CorporateHeroSection />
        <TrainingApproachSection />
        <ProgrammesSection />
        <WhyChooseSection />
        <SETAFundingSection />
        <GetStartedSection />
      </main>
      <Footer />
    </div>
  );
}
